import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { motion, AnimatePresence } from 'framer-motion';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronUp } from '@fortawesome/free-solid-svg-icons';

const ScrollButton = styled(motion.button)`
  position: fixed;
  bottom: 20px;
  right: 95px; // Отступ справа с учетом размещения чат-бота
  width: 45px;
  height: 45px;
  border-radius: 50%;
  background-color: var(--color-primary);
  color: white;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: var(--shadow-md);
  font-size: 1.1rem;
  z-index: 999;
  transition: background-color var(--transition-fast);
  
  &:hover {
    background-color: #1976d2;
  }
  
  @media (max-width: 768px) {
    right: 85px;
    bottom: 20px;
  }
`;

const ScrollToTop = () => {
  const [isVisible, setIsVisible] = useState(false);
  
  // Функция для отслеживания позиции скролла
  const toggleVisibility = () => {
    if (window.pageYOffset > 300) {
      setIsVisible(true);
    } else {
      setIsVisible(false);
    }
  };
  
  // Функция для прокрутки вверх
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };
  
  useEffect(() => {
    window.addEventListener('scroll', toggleVisibility);
    return () => window.removeEventListener('scroll', toggleVisibility);
  }, []);
  
  return (
    <AnimatePresence>
      {isVisible && (
        <ScrollButton
          onClick={scrollToTop}
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: 20 }}
          transition={{ duration: 0.3 }}
          aria-label="Прокрутить вверх"
          title="Прокрутить вверх"
        >
          <FontAwesomeIcon icon={faChevronUp} />
        </ScrollButton>
      )}
    </AnimatePresence>
  );
};

export default ScrollToTop; 